import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import { getCandleColorFromPriceTrend } from '../utils/portfolio';
const StockCandleBar = ({ timeStamp, priceTrend, selectedInfoObj, priceHighLowTop, priceHighLowHeight, priceOpenCloseTop, priceOpenCloseHeight, }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const containerAnimatedStyles = useAnimatedStyle(() => ({
        opacity: !selectedInfoObj.value || selectedInfoObj.value?.timeStamp === timeStamp ? 1 : 0.5,
    }), [selectedInfoObj, timeStamp]);
    const highLowAnimatedStyles = useAnimatedStyle(() => ({
        backgroundColor: selectedInfoObj.value?.timeStamp === timeStamp
            ? colors.elements.secondaryTransparent
            : colors.elements.secondaryLightTransparent,
    }), [colors.elements.secondaryLightTransparent, colors.elements.secondaryTransparent, selectedInfoObj, timeStamp]);
    if (priceHighLowTop === undefined) {
        return <View style={styles.eachCandleContainer}/>;
    }
    return (<View style={styles.eachCandleContainer}>
      <Animated.View style={[
            styles.highLowView,
            { marginTop: priceHighLowTop, height: priceHighLowHeight },
            highLowAnimatedStyles,
            containerAnimatedStyles,
        ]}/>
      <View style={styles.openCloseViewWrapper}>
        <View style={[
            styles.openCloseView,
            {
                marginTop: priceOpenCloseTop,
                height: priceOpenCloseHeight,
            },
        ]}>
          <Animated.View style={[
            styles.innerView,
            { backgroundColor: colors.elements[getCandleColorFromPriceTrend(priceTrend)] },
            containerAnimatedStyles,
        ]}/>
        </View>
      </View>
    </View>);
};
export default React.memo(StockCandleBar);
const styleSet = createStyleSheets((colors) => ({
    eachCandleContainer: {
        flex: 1,
        alignItems: 'center',
    },
    highLowView: {
        width: rem(1),
    },
    openCloseViewWrapper: {
        alignItems: 'center',
        ...StyleSheet.absoluteFillObject,
    },
    openCloseView: {
        width: '60%',
        borderRadius: rem(1),
        backgroundColor: colors.cards.onDark,
    },
    innerView: {
        flex: 1,
        borderRadius: rem(1),
    },
}));
